<template>
  <!-- Page Header-->
  <Header :title="title" :subtitle="subtitle" />
  <!-- Main Content-->
  <main>
    <div class="container px-4 px-lg-5">
      <div class="row gx-4 gx-lg-5 justify-content-center">
        <div class="col-md-10 col-lg-8 col-xl-8">
          <div class="block">
            <div class="radio">
              <el-radio-group v-model="reverse" @click="handleCheckChange" style="padding-bottom: 1rem;">
                <el-radio :label="true">倒序</el-radio>
                <el-radio :label="false">正序</el-radio>
              </el-radio-group>
            </div>
            <el-timeline :reverse="reverse">
              <el-timeline-item v-for="(activity, index) in activities" :key="index" :timestamp="activity.date">
                {{ activity.content }}
              </el-timeline-item>
            </el-timeline>
          </div>
          <h2>计划</h2>
          <p>→想要实装一个功能，点击服设可以看到相关的稿件</p>
          <p><s>→想要让人物关系性简介适配手机端</s>现在不适配电脑端了……</p>
          <p>→想要登陆功能</p>
          <p>→想要让服设和稿图也能分页加载</p>
          <p>→修bug</p>
          <p>→想要给图片重新打标签</p>
          <p>→文章页面h3标签无法传送</p>
          <p>→备注页的英语字体不一致</p>
        </div>
      </div>
    </div>
  </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import axios from 'axios'
import { ref, onMounted } from 'vue'
const title = '日志'
const subtitle = '施工记录'

const reverse = ref([])
reverse.value = true
const activities = ref([])

const getData = () => {
  var api = '/log.php'
  axios
    .get(api)
    .then(res => {
      activities.value = res.data.reverse()
    })
    .catch(err => {
      console.log(err)
    })
}

onMounted(() => {
  getData()
})

const handleCheckChange = val => {
  activities.value = activities.value.reverse()
}
</script>